// extracted by mini-css-extract-plugin
export default {"rating":"zD-z","numberOfStars":"AD-z","count":"BD-z","barGraphSpacing":"CD-z","barGraph":"DD-z"};